module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-8.e3464f6e.png";